<template>
    <div class="md:aspect-w-9 md:aspect-h-6 space-y-6 p-6 md:space-y-auto md:p-auto" >
        <div class="flex flex-col justify-between w-full">
            <div class="flex flex-1 w-full justify-center items-center">

                <div v-if="!recordingUrl" class="tabular-nums text-6xl tracking-tight">
                    {{ recordedTime }}
                </div>

                <div v-if="file" class="">
                    <audio controls>
                      <source :src="recordingUrl" type="audio/mpeg">
                    Your browser does not support the audio element.
                    </audio>
                    <!-- <div class="flex items-center justify-center text-white w-24 h-24 cursor-pointer bg-regal-blue-700 rounded-full" @click="play" v-if="!playing">
                        <svg class="fill-current w-6 h-6 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
                    </div>
                    <div class="flex items-center justify-center text-white w-24 h-24 cursor-pointer bg-regal-blue-700 rounded-full" @click="pause" v-if="playing">
                        <svg class="fill-current w-12 h-12" viewBox="0 0 512 512"> <g> </g> <path d="M162.642 148.337h56.034v215.317h-56.034v-215.316z"/> <path d="M293.356 148.337h56.002v215.317h-56.002v-215.316z" /></svg>
                    </div> -->
                </div>
            </div>

            <!-- <div class="flex flex-col w-full items-center justify-center px-3">
                <micro-player v-show="recordingUrl" :src="src"/>
            </div> -->

            <div class="w-full flex flex-col items-center justify-center space-y-3">
                <div v-if="loading" class="flex items-center justify-center w-16 h-16 rounded-full cursor-pointer">
                    <svg class="animate-spin h-8 w-8 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <div v-if="!recordingUrl && !loading" v-on="recording ? { click: stopRecording } : { click: startRecording }" class="flex items-center justify-center w-16 h-16 rounded-full cursor-pointer"
                    :class="{ 'bg-gray-400': !recording, 'border-2 border-gray-400 bg-white': recording}">
                    <div v-show="!recording" class="w-14 h-14 box-content rounded-full bg-red-500 border-2 border-white">
                    </div>
                    <div v-show="recording" class="w-6 h-6 bg-red-500 rounded-sm"></div>
                </div>
                <div class="flex space-x-2 mb-3">
                    <div v-if="recordingUrl && !loading" class="cursor-pointer flex items-center justify-center h-12 my-2 px-8 font-bold rounded-full border-2 border-red-500 text-red-500" @click="reset">
                        Reset
                    </div>
                    <div v-if="recordingUrl && !loading && file" class="flex items-center cursor-pointer justify-center h-12 my-2 px-8 font-bold rounded-full text-white bg-regal-blue-700" @click="$emit('recordingFinished', file)">
                        Upload
                    </div>
                </div>
                <div class=" text-center text-xs text-gray-600 w-72">
                    <p>Your browser may ask permission to use your microphone. Choose <span class="font-bold">Allow</span> to start recording. Max. recording time: 30 min.</p>
                </div>
            </div>


            <!-- <div class="absolute bottom-0 py-6 flex flex-col justify-center items-center w-full space-y-5 bg-white">

                <div v-if="previewAvailable" class="flex w-full items-center justify-center space-x-3">
                    <button class="flex items-center justify-center h-12 my-2 px-8 font-bold rounded-full border-2 border-red-500 text-red-500">Reset</button>
                    <button @click="submit" class="flex items-center justify-center h-12 my-2 px-8 font-bold rounded-full text-white bg-purple-700">Next</button>
                </div>

                <div v-if="!previewAvailable" @click="recording =! recording" class="flex items-center justify-center w-16 h-16 rounded-full"
                    :class="{ 'bg-gray-200': !recording, 'border-2 border-gray-200 bg-white': recording}">
                    <div v-show="!recording" class="w-14 h-14 box-content rounded-full bg-red-500 border-2 border-white">
                    </div>
                    <div v-show="recording" class="w-6 h-6 bg-red-500 rounded-sm"></div>
                </div>
                <div class=" text-center text-xs text-gray-500 w-72">
                    <p>Your browser may ask permission to use your microphone. Choose <span class="font-bold">Allow</span> to start recording.</p>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script setup>
import axios from 'axios'
import Daily from '@daily-co/daily-js'
import { ref, reactive, onMounted, watch, onUnmounted, onUpdated, computed, defineProps, defineEmits } from 'vue'
import Timer from 'easytimer.js'

// const previewAvailable = ref(false)
const recordingUrl = ref(null)
const recordingTitle = ref(null)
const loading = ref(false)
const recording = ref(false)
const callFrame = ref(null)
const timer = ref(null)
const recordedTime = ref('00:00')
const file = ref(null)

const props = defineProps({
    user: Object
})

onMounted(() => {
    joinRoom({ userName: props.user.name, name: null, moderator: null })
})

onUnmounted(() => {
    callFrame.value.destroy()
})

const emit = defineEmits(['recordingFinished'])

const createRoom = async (roomName) => {
    loading.value = true
    if (roomName) {
        return roomName
    }
    const response = await axios.post(route('rooms.store'))
    const result = await response.data
    return result
}

const createToken = async (roomName) => {
    const response = await axios.post(route('recordings.createToken', {'room_name': roomName, 'user_name': props.user.name }))
    const result = await response.data
    return result
}

const startTimer = () => {
    timer.value = new Timer()
    timer.value.start({ precision: 'seconds', target: {seconds: 1800} })
    timer.value.addEventListener('secondsUpdated', (e) => {
        recordedTime.value = timer.value.getTimeValues().toString(['minutes', 'seconds'])
    })
    timer.value.addEventListener('targetAchieved', (e) => {
        stopRecording()
    })
    timer.value.addEventListener('reset', (e) => {
        timer.value.stop()
        recordedTime.value = '00:00'
    })
}

const stopTimer = () => {
    console.log(timer.value.isRunning())
    timer.value.stop()
}

const resetTimer = () => {
    console.log(timer.value.isRunning())
    timer.value.reset()
    timer.value.removeAllEventListeners('secondsUpdated')
    timer.value.removeAllEventListeners('targetAchieved')
}

const joinRoom = async ({ userName, name, moderator }) => {
    let roomInfo = { name }

    if (!name && !moderator) {
      roomInfo = await createRoom()
    }

    const options = {
      url: 'https://pager.daily.co/' + roomInfo?.name,
      userName: props.user.name,
    }

    let newToken = await createToken(roomInfo?.name)
    options.token = newToken?.token

    const call = Daily.createCallObject({
        audioSource: true,
        videoSource: false,
        dailyConfig: {
            experimentalChromeVideoMuteLightOff: true,
        },
    })

    await call
        .join(options)
        .then(() => {
                callFrame.value = call
                loading.value = false
            })
        .catch((err) => { throw new Error(err) })

    await call.on('recording-stopped', handleRecording)
}

const handleRecording = async () => {
    const delay = t => new Promise(resolve => setTimeout(resolve, t))
    await axios.get(route('recordings.getRecordings', { 'room_name': callFrame.value.room() }))
        .then((res) => {
            recordingUrl.value = res.data.download_link
            recordingTitle.value = res.data.date
            return delay(1000).then(createFile(res.data.download_link, res.data.date + '.mp3'))
        })
}

const startRecording = async () => {
    await callFrame.value.startRecording()
    await callFrame.value.startTranscription()
    loading.value = true
    await callFrame.value.on('recording-started', () => {
        // console.log(callFrame.value.participants())
        loading.value = false
        recording.value = true
        startTimer()
    })
}

const stopRecording = async () => {
    await callFrame.value.stopRecording()
    stopTimer()
    loading.value = true
    recording.value = false
}

const reset = () => {
    recordingUrl.value = null
    recordingTitle.value = null
    file.value = null
    resetTimer()
}

const createFile = async (url, name) => {
    fetch(url)
        .then(res => res.blob())
        .then(blob => {
            file.value = new File([blob], name, {
                type: 'audio/mpeg'
            })
        })
        .then(() => { loading.value = false })
    // const res = fetch(url).then((response) => {
    //     const data = response.blob()
    //     file.value = new File([data], name, {
    //         type: data.type || 'audio/mpeg'
    //     })
    //     loading.value = false
    // }).catch((err) => {
    //     throw new Error('Error')
    // })
}
</script>
